import React, { Component } from 'react';
import './AddCardForm.css';
import CardReactFormContainer from 'card-react';
import userService from '../../services/user.service';

declare var $;
declare var Conekta;
class AddCardForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      cvc: '',
      exp_month: '',
      exp_year: '',
      name: '',
      number: '',
      error: '',
      url: '',
      loadTimes: 0,
      loading: false
    }
   this.setName = this.setName.bind(this);
   this.setNumber = this.setNumber.bind(this);
   this.setDate = this.setDate.bind(this);
   this.setCVC = this.setCVC.bind(this);
   this.addCard= this.addCard.bind(this);
   this.assignCard = this.assignCard.bind(this);
   this.iframeLoaded = this.iframeLoaded.bind(this)
   this.stepBack = this.stepBack.bind(this)
  }

  async componentDidMount() {
    Conekta.setPublicKey('key_fxdYFSNFxYBXTC4sHHXpNEg');
    $('#myModal').appendTo("body")
    if(localStorage.getItem('country') === 'co') {
      let url = await userService.getAddCardUrl()
       url = url.url
      this.setState({
        url
      })
    }
  }

  setName(event) {
    this.setState({
      name: event.target.value
    })
  }

  setNumber(event) {
    this.setState({
      number: event.target.value
    })
  }

  setCVC(event) {
    this.setState({
      cvc: event.target.value
    })
  }

  setDate(event) {
    let date = event.target.value.split("/");
    let exp_month = date[0].replace(" ", "");
    let exp_year = date[1].replace(" ", "");
    this.setState( {
      exp_month,
      exp_year
    })
  }

  async addCard() {
    this.setState({
      loading: true
    })
    let card = { card: {
      cvc: this.state.cvc,
      exp_month: this.state.exp_month,
      exp_year: this.state.exp_year,
      name: this.state.name,
      number: this.state.number
      } }
     Conekta.Token.create(card, (response) => {
      this.setState({
           error: ''
       })
       this.assignCard(response.id)
    },
    (error) => {
      this.setState({
        loading: false
      })
          error = error.message_to_purchaser;
         this.setState({
           error
         })
    });
  }

  async assignCard(id) {
    let response = await userService.assingCard(this.state.number, id )
    if(response.bin) {
      this.props.added(response);
      this.setState({
        loading: false
      })
    } else {
      let error = JSON.parse(response.body).error.message
      this.setState({
        loading: false,
        error
      })
    }
  }

   iframeLoaded() {
   let loadTimes = this.state.loadTimes
   loadTimes++;
   this.setState({
     loadTimes
   })
   if(loadTimes > 1) {
     this.props.added("any");
   }
  }

  stepBack() {
    this.props.show(false)
  }

  render() {
    return (
 <div id="add-card" >
   <header>
   <nav>
    <div className="nav-wrapper no-color">
      <a  className="brand-logo center">Agregar tarjeta</a>
      <a onClick={this.stepBack} className="button-collapse"><i className="material-icons">keyboard_arrow_left</i></a>
    </div>
   </nav>
   </header>
      <div className="content container">
    { (localStorage.getItem('country') != 'co') &&
      <div>
        <div id="card-wrapper"></div>
        <CardReactFormContainer
        container="card-wrapper"


        formInputsNames={
          {
            number: 'CCnumber', // optional — default "number"
            expiry: 'CCexpiry',// optional — default "expiry"
            cvc: 'CCcvc', // optional — default "cvc"
            name: 'CCname' // optional - default "name"
          }
        }

        classes={
          {
            valid: 'valid-input', // optional — default 'jp-card-valid'
            invalid: 'invalid-input' // optional — default 'jp-card-invalid'
          }
        }
        formatting={true}
      >
        <form className="row center animated fadeIn center">
          <div className="col s12">
            <input placeholder="Nombre" value={this.state.name} onChange={this.setName} type="text" name="CCname" />
          </div>
          <div className="col s12">
            <input placeholder="Numero"  onChange={this.setNumber} type="text" name="CCnumber" />
          </div>
          <div className="col s6">
           <input placeholder="MM/AA"  onChange={this.setDate} type="text" name="CCexpiry" />
         </div>
          <div className="col s6">
            <input placeholder="CVC" value={this.state.cvc} onChange={this.setCVC} type="text" name="CCcvc" />
          </div>
        </form>
      </CardReactFormContainer>
            </div>
      }

      { (localStorage.getItem('country') === 'co') &&  <iframe  className="add-card-iframe" onLoad={this.iframeLoaded} src={this.state.url}> </iframe>   }
      </div>


     { (localStorage.getItem('country') != 'co') &&
       <div className="center container">
         {this.state.loading &&
         <div className="progress">
             <div className="indeterminate"></div>
         </div>
         }
        {this.state.error !== '' &&  <p className="error animated shake">{this.state.error}</p> }
           <a className={"btn add btn-default btn-orange " + (this.state.loading ? 'disabled' : ' ')} onClick={this.addCard}>Agregar</a>
        </div>
      }


</div>

    );
  }
}


export default AddCardForm;



// WEBPACK FOOTER //
// ./src/components/add-card-form/AddCardForm.js